import { isPlatformServer } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { AssetPageDataService } from '../../gallery/services/asset-page-data.service';
import { getFullPath } from '../../lib/get-full-path';
import { enableBodyScroll } from '../../lib/toggle-body-scroll';
import { GalleryService } from '../../services/gallery.service';

@Injectable({
  providedIn: 'root',
})
export class ViewGalleryAssetResolve {
  private galleryService = inject(GalleryService);
  private router = inject(Router);
  private assetPageDataService = inject(AssetPageDataService);
  private platformId = inject<string>(PLATFORM_ID);

  async resolve(next: ActivatedRouteSnapshot) {
    const gallery = await this.galleryService.getPublicGalleryFromSnapshot(next, { isPublic: true });
    const assetId = next.params.assetId.replace('}', '');
    const resp = await firstValueFrom(this.assetPageDataService.get(gallery, assetId, next.queryParams));
    if (isPlatformServer(this.platformId)) return resp;
    if (!resp?.asset) {
      enableBodyScroll('asset-page');
      const path = getFullPath(next);
      path.pop();
      console.log('Redirect back to gallery because image doesnt exist in resolve');
      return this.router.navigate(path);
    }
    return resp;
  }
}
